// url
// export default "https://johnsmilgatutorials.com/projects/react-tech-store-v2";

// export default 'http://localhost:1337';

export default "https://hooks-store-api.herokuapp.com";



